<template>
  <SubscriptionContext>
    <template #default="{ activeSubscription, isSuccess }">
      <InvoiceTemplateContext
        v-if="isSuccess && activeSubscription?.invoice_template"
        :invoice-template-id="activeSubscription?.invoice_template"
      >
        <PaymentMethodsContext>
          <RouterView></RouterView>
        </PaymentMethodsContext>
      </InvoiceTemplateContext>
      <Loader v-else />
    </template>
  </SubscriptionContext>
</template>

<script setup lang="ts">
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import InvoiceTemplateContext from '@/components/deepadmin/billing/payment/InvoiceTemplateContext.vue'
import PaymentMethodsContext from '@/components/deepadmin/billing/payment/PaymentMethodsContext.vue'
import SubscriptionContext from '@/components/deepadmin/subscription/SubscriptionContext.vue'
import Loader from '@/components/Loader.vue'

const { permissions } = useAuthorizationContext()
const { selectedOrganization } = useAccountMembershipsContext()

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.billing.payment_details',
  },
})

usePageAccess(
  computed(
    () =>
      !permissions.canManageInvoicing ||
      selectedOrganization.value?.resource.verification?.state !== 'verified',
  ),
)
</script>
